"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryResponseToJSON = exports.DeliveryResponseFromJSONTyped = exports.DeliveryResponseFromJSON = exports.DeliveryResponse = void 0;
/**
 * Toggles the delivery of the entity ON or OFF.
 * @export
 */
exports.DeliveryResponse = {
    On: 'ON',
    Off: 'OFF'
};
function DeliveryResponseFromJSON(json) {
    return DeliveryResponseFromJSONTyped(json, false);
}
exports.DeliveryResponseFromJSON = DeliveryResponseFromJSON;
function DeliveryResponseFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.DeliveryResponseFromJSONTyped = DeliveryResponseFromJSONTyped;
function DeliveryResponseToJSON(value) {
    return value;
}
exports.DeliveryResponseToJSON = DeliveryResponseToJSON;
